<div class="w-full overflow-x-auto">
  <table class="table w-full">
    <thead>
      <tr>
        <th>{{ 'User / Team' | translate | async }}</th>
        @for (op of availableOperations(); track op) {
          <th
            class="text-center"
            >
            {{ op | titlecase }}
          </th>
        }
        <th class="text-right">{{ 'Actions' | translate | async }}</th>
      </tr>
    </thead>
    <tbody>
      @for (entry of accessEntries(); track entry) {
        <tr>
          <td>
            <div class="flex items-center gap-3">
              <div class="avatar">
                <div class="mask mask-squircle bg-primary/10 flex h-10 w-10 items-center justify-center">
                  @if (entry.who === 'user' && entry.whoId) {
                    <tw-user class="text-primary h-6 w-6"></tw-user>
                  }
                  @if (entry.who === 'team') {
                    <tw-team class="text-primary h-6 w-6"></tw-team>
                  }
                  @if (entry.who === 'anonymous') {
                    <span class="text-primary text-xs font-bold">?</span>
                  }
                </div>
              </div>
              <div>
                <div class="font-bold">
                  @if (entry.who === 'user' && entry.whoId) {
                    <lib-user-pill [userId]="entry.whoId"></lib-user-pill>
                  }
                  @if (entry.who === 'team' && entry.whoId) {
                    <lib-team-pill [teamId]="entry.whoId"></lib-team-pill>
                  }
                  @if (entry.who === 'anonymous') {
                    {{ 'Anonymous' | translate | async }}
                  }
                </div>
                <div class="text-xs opacity-50">{{ entry.who | titlecase | translate | async }}</div>
              </div>
            </div>
          </td>
          @for (op of availableOperations(); track op) {
            <td
              class="text-center"
              >
              <input
                type="checkbox"
                class="checkbox checkbox-primary"
                [checked]="entry.operations[op]"
                [disabled]="!canWrite()"
                (change)="togglePermission(entry, op, $event)"
                />
            </td>
          }
          <th class="text-right">
            @if (entry.who === 'team' && entry.whoId) {
              <button
                type="button"
                class="btn btn-ghost btn-xs"
                (click)="goToTeam(entry)"
                >
                {{ 'Go to team' | translate | async }}
              </button>
            }
          </th>
        </tr>
      }

      <!-- Simplified Add Sharing -->
      @if (canWrite()) {
        <tr>
          <td [attr.colspan]="availableOperations().length + 2">
            <div class="flex gap-2">
              <button
                class="btn btn-ghost btn-xs gap-2"
                (click)="startSharingFlow()"
                >
                <tw-user class="h-4 w-4"></tw-user>
                {{ 'Share with User (by email)' | translate | async }}
              </button>
              <button
                class="btn btn-ghost btn-xs gap-2"
                (click)="selectTeamToShare()"
                >
                <tw-team class="h-4 w-4"></tw-team>
                {{ 'Share with Team' | translate | async }}
              </button>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
